import React, { Component } from "react";
import { Link } from "react-router-dom";
import Social from "../section-components/social";
import Copyright from "./copyright";

class Footer_v1 extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const currentYear = new Date().getFullYear();

    return (
      <footer className="bg-dark text-white">
        {/* Main Footer Content */}
        <div className="container py-5 m-10">
          <div className="row align-items-start text-center text-lg-start">
            {/* Left Column: Description */}
            <div className="col-lg-4 mb-4">
              <p className="text-light lead fs-6">
                Medesco : spécialiste de la promotion et de la vente de biens
                résidentiels de qualité à Tanger.
                <br />
                Confort, sécurité, et accompagnement à chaque étape de votre
                projet.
              </p>
            </div>

            {/* Center Column: Logo */}
            <div className="col-lg-4 mb-4 d-flex justify-content-center align-items-start">
              <img
                src={publicUrl + "assets/img/logo.svg"}
                alt="Logo du pied de page"
                width={200}
                height={80}
                className="img-fluid"
              />
            </div>

            {/* Right Column: Contact Info */}
            <div className="col-lg-4 mb-4">
              <div className="mb-3">
                <div className="d-flex align-items-center justify-content-center justify-content-lg-end mb-2">
                  <i className="icon-placeholder me-2 text-primary" />
                  <span className="text-light">Sidi idriss, Tanger</span>
                </div>

                <div className="d-flex align-items-center justify-content-center justify-content-lg-end mb-2">
                  <i className="icon-call me-2 text-primary" />
                  <a
                    href="tel:+212662396925"
                    className="text-white text-decoration-none"
                    onMouseOver={(e) => (e.target.style.color = "#0d6efd")}
                    onMouseOut={(e) => (e.target.style.color = "white")}
                  >
                    +212 6 62 39 69 25
                  </a>
                </div>

                <div className="d-flex align-items-center justify-content-center justify-content-lg-end mb-3">
                  <i className="icon-mail me-2 text-primary" />
                  <a
                    href="mailto:contact@medesco-immobilier.ma"
                    className="text-white text-decoration-none"
                    onMouseOver={(e) => (e.target.style.color = "#0d6efd")}
                    onMouseOut={(e) => (e.target.style.color = "white")}
                  >
                    contact@medesco.ma
                  </a>
                </div>
              </div>

              {/* Social Icons */}
              <div className="d-flex gap-2 justify-content-center justify-content-lg-end">
                <Social />
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-top border-secondary bg-black text-center">
          <div className="container py-3">
            <small className="text-muted d-block mb-2">
              © {currentYear} Medesco. Tous droits réservés.
            </small>
            <div className="d-flex gap-3 justify-content-center">
              <Link
                to="/privacy"
                className="text-muted text-decoration-none small"
                onMouseOver={(e) => (e.target.style.color = "white")}
                onMouseOut={(e) => (e.target.style.color = "#6c757d")}
              >
                Politique de confidentialité
              </Link>
              <Link
                to="/terms"
                className="text-muted text-decoration-none small"
                onMouseOver={(e) => (e.target.style.color = "white")}
                onMouseOut={(e) => (e.target.style.color = "#6c757d")}
              >
                Conditions d'utilisation
              </Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer_v1;
